import { useEffect, useState } from "react";

// Tracks browsers online state
export default function useOnline(): boolean {
  const [onlineStatus, setOnlineStatus] = useState(window.navigator.onLine);

  function setOffline() {
    setOnlineStatus(false);
  }

  function setOnline() {
    setOnlineStatus(true);
  }

  useEffect(() => {
    window.addEventListener("online", setOnline);
    window.addEventListener("offline", setOffline);
    return () => {
      window.removeEventListener("online", setOnline);
      window.removeEventListener("offline", setOffline);
    };
  }, []);

  return onlineStatus;
}
